import React from 'react';
import Button from "../../../forms/Button";
import { Tooltip } from "react-tooltip";

const TransactionDetails = ({ data }) => {
  const transactionStatusHexColorMap = {
    "Success": "#06D6A0",
    "Failed": "#ef427c",
  };

  return (
    <>
      <div className="relative bg-white py-4 px-4 shadow shadow-md-pink/20 rounded-lg" style={{ "--transactionStatuColor": transactionStatusHexColorMap[data?.transactionstatus] }}>
        <div className="mb-4 pb-4 border-b border-md-pink-light-1 flex items-center justify-between gap-4 flex-wrap">
          <div className="text-lg 2xl:text-xl text-md-dark font-semibold">Transaction Details</div>
          <div className="ml-auto">
            <div data-tooltip-id="download-invoice">
              <Button buttonHasLink={false} buttonIcon={"fa-regular fa-fw fa-download"} buttonIconPosition={"left"} buttonLabel={<span className="hidden lg:inline-block">Invoice</span>} buttonClasses={"!h-auto !rounded !px-2 !py-1 !text-md-pink !bg-transparent hover:!bg-md-pink/10 !gap-1"} buttonLabelClasses={"!font-semibold !text-md-dark !text-sm"} buttonFunction={() => { }} />
              <Tooltip
                id="download-invoice"
                place="top"
                className="!py-1 !px-2 !text-xs !bg-md-pink !bg-opacity-100 z-10 !block 2xl:!hidden"
                render={() => (
                  <div className="text-white">Download Invoice</div>
                )}
              />
            </div>
          </div>
        </div>
        <div className="relative">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-0.5 flex flex-col items-start">
              <div className="text-[10px] 2xl:text-xs uppercase !leading-none text-slate-400 tracking-wide">Transaction ID</div>
              <div className="text-sm 2xl:text-base font-medium !leading-none">{data?.transactionid}</div>
            </div>
            <div className="space-y-0.5 flex flex-col items-end">
              <div className="text-[10px] 2xl:text-xs uppercase !leading-none text-slate-400 tracking-wide">Transaction Status</div>
              <div className="text-sm 2xl:text-base font-semibold inline-block !leading-none" style={{ color: "var(--transactionStatuColor)" }}>
                {data?.transactionstatus}
              </div>
            </div>
            <div className="space-y-0.5 flex flex-col items-start">
              <div className="text-[10px] 2xl:text-xs uppercase !leading-none text-slate-400 tracking-wide">Transaction Date</div>
              <div className="text-sm 2xl:text-base font-medium !leading-none">{data?.orderdate}</div>
            </div>
            <div className="space-y-0.5 flex flex-col items-end">
              <div className="text-[10px] 2xl:text-xs uppercase !leading-none text-slate-400 tracking-wide">Transaction Amount</div>
              <div className="text-sm 2xl:text-base font-medium !leading-none">{'$' + data?.transactionamount}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransactionDetails;